import { useState } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'

import passwordOutcome from 'components/authentication/passwordOutcome'
import SetPassword from 'components/authentication/form-fields/SetPassword'
import SignedOutForm, {
  SignedOutFormContainer
} from 'components/authentication/SignedOutForm'
import toast from 'lib/toast'
import authenticationAPI from 'api/authentication'
import { messageFromResponseError } from 'utils/strings'

const EXPIRED_CODE_MSG = 'The provided reset code is invalid or expired'

function ResetPassword({
  history,
  location,
  resetPassword = authenticationAPI.resetPassword
}) {
  const { code, email: defaultEmail } = queryString.parse(location.search)

  const [email, setEmail] = useState(defaultEmail)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleChange = event => {
    switch (event.target.name) {
      case 'email':
        setEmail(event.target.value)
        break

      case 'password':
        setPassword(event.target.value)
        break

      case 'confirmPassword':
        setConfirmPassword(event.target.value)
        break
    }
  }

  const handleSubmit = async event => {
    if (submitting) {
      return
    }

    event.preventDefault()
    setSubmitting(true)

    try {
      await resetPassword(code, email, password)

      toast({
        type: 'success',
        text: 'Password reset successfully.'
      })

      setSubmitting(false)
      history.push('/')
    } catch (err) {
      const message = messageFromResponseError(
        err,
        'Unable to reset password. Please try again later.'
      )
      toast({
        type: 'error',
        text: message
      })

      setSubmitting(false)
      if (message === EXPIRED_CODE_MSG) {
        history.push('/')
        return
      }
    }
  }

  return (
    <SignedOutFormContainer>
      <SignedOutForm title="Reset your Password" onSubmit={handleSubmit}>
        <SetPassword
          confirmPassword={confirmPassword}
          handleChange={handleChange}
          hideAcceptPrivacyPolicy={true}
          isLoading={submitting}
          password={password}
          passwordOutcome={passwordOutcome}
          submitLabel="Submit Password Reset"
        />
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}

ResetPassword.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  resetPassword: PropTypes.func
}

export default ResetPassword
